import { Text, TextColor, TextSize, TextWeight } from '@vizit/atoms';
import { Skeleton } from '@vizit/atoms';
import { cx } from '@vizit/theme';
import * as React from 'react';

interface ProductHeaderInfoItemProps extends React.HTMLAttributes<HTMLDivElement> {
  /**
   * The label of the product header info item
   * @required
   * @type {string}
   */
  label: string;
  /**
   * The value of the product header info item
   * @optional
   * @type {string}
   * @default '-'
   */
  value?: string;
  /**
   * Whether the product header info item is loading
   * @required
   * @type {boolean}
   */
  isLoading: boolean;
}

const ProductHeaderInfoItem = React.memo(
  ({ label, value = '-', isLoading, className, ...other }: ProductHeaderInfoItemProps) => {
    return (
      <div className={cx('flex flex-col', className)} aria-label={`${label} information`} {...other}>
        <Text
          showEllipsis
          elementType="span"
          size={TextSize.Sm}
          weight={TextWeight.Semibold}
          color={TextColor.Tertiary}
        >
          {label}
        </Text>
        {isLoading ? (
          <Skeleton className="h-12 w-1/2" variant="square" aria-label={`Loading ${label}`} />
        ) : (
          <Text
            showEllipsis
            elementType="span"
            size={TextSize.Sm}
            color={TextColor.Primary}
            weight={TextWeight.Regular}
          >
            {value}
          </Text>
        )}
      </div>
    );
  },
);

export { ProductHeaderInfoItem };
